import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  base: {
    fill: colors.primaryIcon,
  },
  arrowTransition: (isOpenOptions) => ({
    transform: isOpenOptions ? 'rotate(180deg)' : '',
    transition: 'transform 0.3s ease',
  }),
  large: {
    width: '28px',
    height: '28px',
  },
  medium: {
    width: '24px',
    height: '24px',
  },
  small: {
    width: '16px',
    height: '16px',
  },
});
